import { render, staticRenderFns } from "./adminEdit.vue?vue&type=template&id=76f62532&"
import script from "./adminEdit.vue?vue&type=script&lang=js&"
export * from "./adminEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports